<template>
  <a-form-item name="survey_submission_type" label="Envío de IVR tipo encuesta de satisfacción">
    <div class="group__info">
      <!-- <span>
        <InfoCircleOutlined />
      </span> -->
      <p class="info">
        Define si las encuestas seleccionadas se enviará automáticamente al finalizar una llamada o
        si quedará a criterio del usuario decidir si enviarla tras su gestión.
      </p>
    </div>

    <a-radio-group :value="sentType" @update:value="emit('update:sentType', $event)">
      <a-radio :value="SentType.None" :style="radioStyle">Ninguno</a-radio>
      <a-radio :value="SentType.Automatic" :style="radioStyle"> Automático </a-radio>
      <a-radio :value="SentType.ByUser" :style="radioStyle"> A criterio del usuario </a-radio>
    </a-radio-group>

    <a-form-item
      class="ivr-picker"
      name="ivr"
      label="Elige tu encuesta de satisfacción"
      :required="sentType !== SentType.None"
    >
      <a-tooltip
        :title="
          sentType === SentType.None
            ? 'Para habilitar esta opción, recuerda  seleccionar si el envío de tu IVR será automático o a criterio del usuario. '
            : null
        "
      >
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          :value="ivr"
          :disabled="sentType === SentType.None"
          placeholder="Selecciona tu encuesta de satisfacción"
          @update:value="emit('update:ivr', $event)"
        >
          <a-select-option v-for="bot in ivrs" :key="bot.id">{{ bot.name }}</a-select-option>
        </a-select>
      </a-tooltip>
    </a-form-item>
  </a-form-item>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

import { SentType } from "@/@types/ivr/sent";
import { botServices } from "@/app/ivr/bot/services/BotServices";
import { Bot } from "@/@types/ivr";
import { BotStatus, BotType } from "@/app/ivr/bot/utils/enums";

const props = defineProps<{
  sentType?: SentType | null;
  ivr?: number | null;
  radioStyle?: CSSStyleSheet | { display: string; height: string; lineHeight: string };
}>();

const emit = defineEmits<{
  "update:sentType": [sentType: SentType];
  "update:ivr": [ivr: number | null];
}>();

const ivrs = ref<Bot[]>([]);

const fetchIvrs = async () => {
  ivrs.value = await botServices.getList({ type: BotType.Survey, status: BotStatus.Active });
};

watch(
  () => props.sentType,
  (newSentType) => {
    if (newSentType === SentType.None) emit("update:ivr", null);
  }
);

onMounted(() => fetchIvrs());
</script>

<style scoped lang="sass">
.group__info
  color: $gray-8
  font-style: italic
  font-size: 12px
  display: flex

.info
  margin-left: 5px
  margin-bottom: 0

.ivr-picker
  margin: 20px 0 0

:deep(label[for="form_item_ivr"])
  font-size: 14px
  font-weight: 400
</style>
